export const environment = {
  base_url: process.env.REACT_APP_BASE_URL,
  sass_url: process.env.REACT_APP_BASE_URL_SASS,
  digital_id: process.env.REACT_APP_BASE_URL_DIGITAL_ID,
  loyalty_url: process.env.REACT_APP_BASE_URL_MERCHANT,
};
